export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14523.989d9977.jpg";